import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref } from 'vue'
import { t } from '@/plugins/i18n'
import AddressListModal from './AddressListModal.vue'

export default /*#__PURE__*/_defineComponent({
  props: ['countryList'],
  emits: ['submit'],
  setup(__props, { emit: emits }) {

const props = __props


const addressListModalRef = ref()
const open = () => {
  addressListModalRef.value.open()
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_button, {
      class: "add-address-btn",
      onClick: open
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('导入常用地址')), 1)
      ]),
      _: 1
    }),
    _createVNode(AddressListModal, {
      ref: (_value, _refs) => {
        _refs['addressListModalRef'] = _value
        addressListModalRef.value = _value
      },
      countryList: __props.countryList,
      onSubmit: _cache[0] || (_cache[0] = v => emits('submit', v))
    }, null, 8, ["countryList"])
  ], 64))
}
}

})